(function () {
  'use strict';

  angular
    .module('eclipseApp.linkAccount')
    .controller('verifyNumberController', VerifyNumberController);

  VerifyNumberController.$inject = [
    '$rootScope',
    'linkAccountService',
    '$state',
    'userService',
    'dtmService',
    'dtmServiceConstants',
    '$translate',
    '$modalInstance',
    'modalConfig',
    '$window',
    'ute.datalayer.common.service'
  ];

  function VerifyNumberController($rootScope,
                                  linkAccountService,
                                  $state,
                                  userService,
                                  dtmService,
                                  dtmServiceConstants,
                                  $translate,
                                  $modalInstance,
                                  modalConfig,
                                  $window,
                                  dataLayerService) {
    var ctrl = this;
    var dtmRule;
    init();

    /* Send verification code to user phone */
    ctrl.validateCode = function (form) {
      if (form.$valid) {
        ctrl.isSendingPrepaid = true;
        ctrl.verification.code = '' + ctrl.verification.digit1 + ctrl.verification.digit2 + ctrl.verification.digit3 + ctrl.verification.digit4;

        linkAccountService.validateLinkAccountPrepaidSubscriber($rootScope.userInfo.uuid, modalConfig.phoneNo, ctrl.verification.code, $rootScope.userInfo.userID)
          .then(function (result) {
            if (result.data.error || result.data.status === 'Failed') {
              ctrl.formError = result.data.error;
            } else {
              linkAccountService.processUserInfo(result.data.getCustomerAccounts);
              $modalInstance.close(true); //shows success message
              dataLayerService.track({}, false, [0, 1, 4], {mappingKey: 'linkAccounts.complete'});
            }
          })
          .catch(function () {
            ctrl.formError = '50000';
          })
          .finally(function () {
            ctrl.isSendingPrepaid = false;
          });
      } else {
        if (ctrl.verification.code == null) {
          $translate('global.error.inline.verificationCode.required')
            .then(function (translatedValue) {
              var clientSideError = 'CS|' + translatedValue;
              dtmService.setVar(dtmRule.eVar, clientSideError);
              dtmService.direct(dtmRule.errorRule);
            });
        }
      }
    };

    ctrl.resendCode = function () {
      ctrl.isResendingCode = true;
      ctrl.isResendingCodeFailed = false;
      ctrl.isResendingCodeSuccess = false;
      linkAccountService.linkAccountPrepaidSubscriber($rootScope.userInfo.uuid || $window.sessionStorage.getItem('guid'), modalConfig.phoneNo)
        .then(function (result) {
          if (result.data.error || result.data.status === 'Failed') {
            ctrl.isResendingCodeFailed = true;
            ctrl.formError = result.data.error;
          } else {
            ctrl.isResendingCodeSuccess = true;
          }
        })
        .catch(function () {
          ctrl.formError = '50000';
        })
        .finally(function () {
          ctrl.isResendingCode = false;
        });
    };

    ctrl.showResendCode = function () {
      ctrl.showResendButton = !ctrl.showResendButton;
    };

    ctrl.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    function init() {
      if (!modalConfig.phoneNo || modalConfig.phoneNo.length !== 10) {
        ctrl.cancel();
      }
      dtmRule = dtmServiceConstants.dtmRules.dtmLinkAccount;
      ctrl.phoneNo = modalConfig.phoneNo;
      ctrl.showResendButton = false;
      ctrl.isSendingPrepaid = false;
      ctrl.isSendingCode = false;
      ctrl.verification = {
        digit1: null,
        digit2: null,
        digit3: null,
        digit4: null,
        code: null
      };
    }

    setTimeout(function () {
      angular.element('#verificationCode01').focus();
    });
  }
})();
